import React, { memo, useMemo } from "react";
import { Colors, FontFamily } from "../../../constants/Colors";

const GREEN_STYLE = { background: Colors.statusGreen, color: Colors.verizonWhite };
const RED_STYLE = { background: Colors.statusRed, color: Colors.verizonWhite };
const GRAY_STYLE = { background: Colors.statusGray, color: Colors.verizonWhite };
const ORANGE_STYLE = { background: Colors.statusOrange, color: Colors.verizonWhite };
const LIGHT_ORANGE_STYLE = { background: Colors.statusLightOrange, color: Colors.verizonBlack };

const STATUS_COLOR_MAP = {
  neverscheduled: GRAY_STYLE,
  scheduled: GREEN_STYLE,
  installedfailed: RED_STYLE,
  needsaction: ORANGE_STYLE,
  notinstalled: ORANGE_STYLE,
  installed: GREEN_STYLE,
  // aggregated vehicle-level installation statuses
  nothinginstalled: GRAY_STYLE,
  partiallyscheduled: LIGHT_ORANGE_STYLE,
  partiallyinstalled: LIGHT_ORANGE_STYLE,
  //add colors for below - shipping status
  delivered: GREEN_STYLE,
  shipped: GREEN_STYLE,
  packaging: GREEN_STYLE,
  created: GRAY_STYLE,
  submitted: GRAY_STYLE,
  backordered: LIGHT_ORANGE_STYLE,
  exception: LIGHT_ORANGE_STYLE,
  returntosender: LIGHT_ORANGE_STYLE,
  cancelled: RED_STYLE,
  returned: RED_STYLE,
  error: RED_STYLE,
  // hardware status
  ready: GREEN_STYLE,
  warning: LIGHT_ORANGE_STYLE,
};

const normalize = (str) => str?.toLowerCase().replace(/[\s-]+/g, "") ?? "";

const DEFAULT_STYLE = GRAY_STYLE;

const baseStyle = {
  minWidth: "23px",
  display: "inline-block",
  padding: "2px 4px",
  borderRadius: "4px",
  fontFamily: FontFamily.primary,
  fontSize: "12px",
  fontWeight: "700",
  lineHeight: "16px",
  whiteSpace: "nowrap",
  userSelect: "none",
};

const StatusBadge = memo(({ status }) => {
  const colorStyle = useMemo(() => STATUS_COLOR_MAP[normalize(status)] ?? DEFAULT_STYLE, [status]);
  if (!status) return <span></span>;
  return (
    <span
      style={{
        ...baseStyle,
        backgroundColor: colorStyle.background,
        color: colorStyle.color,
      }}
    >
      {status}
    </span>
  );
});

StatusBadge.displayName = "StatusBadge";

export default StatusBadge;
